<div mat-dialog-title fxLayoutAlign="space-between center">
  <h2>
    {{ (data.method === 'sms' ? 'send-contact-edit-dialog.prompt-sms' : 'send-contact-edit-dialog.prompt-email') | translate }}
  </h2>
</div>
<mat-dialog-content class="pt-5" fxLayout="column">
  <mat-form-field *ngIf="data.method === 'email'">
    <mat-label>{{ 'send-contact-edit-dialog.label-email' | translate }}</mat-label>
    <input
      matInput
      [formControl]="contactControl"
      type="email"
      cdkFocusInitial
    />
    <mat-error *ngIf="contactControl?.errors?.['required']">{{ 'send-contact-edit-dialog.error-required' | translate }}</mat-error>
    <mat-error *ngIf="contactControl?.errors?.['email']">{{ 'send-contact-edit-dialog.error-invalid-email' | translate }}</mat-error>
  </mat-form-field>

  <mat-form-field *ngIf="data.method === 'sms'">
    <mat-label>{{ 'send-contact-edit-dialog.label-phone' | translate }}</mat-label>
    <mmx-phone-field [formControl]="contactControl"></mmx-phone-field>
    <mat-error *ngIf="contactControl?.errors?.['required']">{{ 'send-contact-edit-dialog.error-required' | translate }}</mat-error>
  </mat-form-field>

  <div *ngIf="isCustomValue" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="8px" class="custom-value-hint">
    <span fxFlex>{{ ('send-contact-edit-dialog.hint-custom-' + data.method) | translate }}</span>
    <button mat-stroked-button type="button" style="white-space: nowrap" (click)="reset()">{{ 'send-contact-edit-dialog.hint-reset' | translate }}</button>
  </div>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
  <button mat-stroked-button (click)="dialogRef.close()">
    {{ 'common.cancel' | translate }}
  </button>
  <button
    mat-flat-button
    color="primary"
    [disabled]="contactControl?.invalid"
    (click)="send()"
  >
    {{ 'common.send' | translate }}
  </button>
</mat-dialog-actions>
